import React from 'react';
import { colors, spacing, typography } from '../../../design-system/index.js';

export const BioHeader = () => {
  const sectionStyles = {
    padding: `${spacing[16]} 0 ${spacing[12]}`,
    textAlign: 'center',
    borderBottom: `1px solid ${colors.border.light}`,
  };

  const displayNameStyles = {
    fontSize: typography.fontSize['3xl'],
    fontWeight: typography.fontWeight.light,
    lineHeight: typography.lineHeight.tight,
    letterSpacing: typography.letterSpacing.tighter,
    color: colors.text.primary,
    marginBottom: spacing[4],
    margin: 0,
  };

  const taglineStyles = {
    fontSize: typography.fontSize.lg,
    fontWeight: typography.fontWeight.light,
    lineHeight: typography.lineHeight.loose,
    color: colors.text.secondary,
    maxWidth: '600px',
    margin: '0 auto',
    letterSpacing: typography.letterSpacing.wide,
  };

  const decorativeLineStyles = {
    width: '60px',
    height: '2px',
    backgroundColor: colors.text.primary,
    margin: `${spacing[6]} auto`,
    borderRadius: '2px',
  };

  return (
    <section style={sectionStyles} className="bio-header">
      <h1 style={displayNameStyles} className="display-name">
        张三
      </h1>
      
      <div style={decorativeLineStyles} />
      
      <p style={taglineStyles} className="tagline">
        全栈开发工程师 · 设计系统构建者 · 开源贡献者
        <br />
        专注于创造优雅的用户体验和高质量的代码
      </p>
    </section>
  );
};
